import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CruceDatos } from '../../../models/cruce-datos.model';
import { AlertService } from '../../../services/util/alert.service';
import * as FileSaver from 'file-saver';
import { DataEmpresaService } from '../../../services/data-empresa.service';
import { CmsSeccionesService } from '../../../services/cms-secciones.service';

@Component({
  selector: 'app-busqueda-masiva-datos-encontrados',
  templateUrl: './busqueda-masiva-datos-encontrados.component.html',
  styleUrls: ['./busqueda-masiva-datos-encontrados.component.css'],
})
export class BusquedaMasivaDatosEncontradosComponent implements OnInit {
  cruceDatosResult: CruceDatos = new CruceDatos();

  // PARA EL FILTRADO
  ambientales: boolean = true;
  laborales: boolean = true;
  multas: boolean = true;
  derrames: boolean = true;
  accidentes: boolean = true;
  estructura: boolean = true;
  representantes: boolean = true;
  proyectos: boolean = true;
  permisos: boolean = true;

  subcategoriasFlexibles: any[] = [];
  subcategoriasSeleccionadas: { [id: string]: boolean } = {};

  formatosDescarga: any[] = [
    { id: 'Archivo de excel', value: 1 },
    { id: 'Archivo PDF', value: 2 },
  ];
  selectedFormato: any;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public _alertService: AlertService,
    public _dataEmpresaService: DataEmpresaService,
    public _CmsSeccionesService: CmsSeccionesService
  ) {
    this.getResultadosFromCruce(this.route);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.selectedFormato = this.formatosDescarga[0];
    this.getSubcategorias();
  }

  getResultadosFromCruce(route: ActivatedRoute) {
    route.queryParams.subscribe(async (params) => {
      try {
        if (params['resultados']) {
          this.cruceDatosResult = JSON.parse(params['resultados']);
          this._alertService.closeAlert();
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  verBusquedaResultados() {
    this.router.navigate(['/busqueda-masiva']);
  }

  descargarResultados() {
    let filtros = this.getFiltros();
    const rucsString = this.cruceDatosResult.rucs.map((ruc) => ruc.toString());

    if (this.selectedFormato.value === 1) {
      this._dataEmpresaService
        .getCruceEmpresaDownloadFile(rucsString, filtros)
        .subscribe((result) => {
          this.exportExelFile(result, 'resultados-busqueda-masiva');
        });
    } else {
      this._dataEmpresaService
        .getCruceEmpresaDownloadFilePDF(rucsString, filtros)
        .subscribe(
          (result) => {
            this.exportPDFFile(result, 'resultados-busqueda-masiva');
          },
          (error) => {
            console.log('error', error);
          }
        );
    }
  }

  exportExelFile(data, filename) {
    const blobValue = new Blob([data['body']], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    FileSaver.saveAs(blobValue, filename + '.xlsx');
  }

  exportPDFFile(data, filename) {
    const blobValue = new Blob([data['body']], {
      type: 'application/pdf',
    });
    FileSaver.saveAs(blobValue, filename + '.pdf');
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  downloadFile2(response: any, fileName?: string) {
    const blob = new Blob([response.body], {
      type: response.headers.get('content-type'),
    });
    fileName =
      fileName || response.headers.get('content-disposition').split(';')[0];
  }

  getFiltros() {
    let resultFiltro: (string | number)[] = [];

    if (this.ambientales) resultFiltro.push('fac_infracciones_ambientales');
    if (this.laborales) resultFiltro.push('fac_infracciones_laborales');
    if (this.multas) resultFiltro.push('fac_multas_perdonadas');
    if (this.derrames) resultFiltro.push('fac_informacion_derrames');
    if (this.accidentes) resultFiltro.push('fac_informacion_accidentes');
    if (this.estructura) resultFiltro.push('fac_estructura');
    if (this.representantes) resultFiltro.push('fac_representantes');
    if (this.proyectos) resultFiltro.push('fac_informacion_proyectos');
    if (this.permisos) resultFiltro.push('fac_informacion_permisos');

    for (const [idStr, activo] of Object.entries(
      this.subcategoriasSeleccionadas
    )) {
      if (activo) {
        const id = Number(idStr);
        if (!isNaN(id)) resultFiltro.push(id);
      }
    }

    return resultFiltro;
  }
  
  public getSubcategorias(): void {
  this._CmsSeccionesService.getAllSubCategories().subscribe({
    next: (subcategoriasResp: any[]) => {
      this._dataEmpresaService.getIndicadoresEmpresa('').subscribe({
        next: (indicadoresResp: any) => {
          const indicadores = indicadoresResp.data || [];

          const titulosConDatos = indicadores.map((ind) =>
            ind.title?.toUpperCase()?.trim()
          );

          this.subcategoriasFlexibles = subcategoriasResp.filter((subcat) =>
            titulosConDatos.includes(subcat.title?.toUpperCase()?.trim())
          );

          this.subcategoriasFlexibles.forEach((subcat) => {
            this.subcategoriasSeleccionadas[subcat.id] = true;
          });
        },
        error: (err) => {
          console.error('Error al obtener indicadores:', err);
        }
      });
    },
    error: (err) => {
      console.error('Error al obtener subcategorías:', err);
    }
  });
}
}
